import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { searchObj } from './utils/util'
import { islocation, isEntity } from './utils/entity';
const searchProps = searchObj(window.location.search);
// 小语种直接跳转海外工单
if (searchProps.lang) {
  if (!['zh_cn', 'en'].includes(searchProps.lang) && isEntity("youzu")) {
    if (islocation('qa') || islocation('dev') || islocation('prv')) {
      console.log("开始跳转", "http://qamsupport.gtarcade.com/default/verify" + window.location.search)
      window.location.href = "https://qamsupport.gtarcade.com/default/verify" + window.location.search
    } else {
      window.location.href = "https://msupport.gtarcade.com/default/verify" + window.location.search
    }
  }
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
